import { Component, inject, input } from '@angular/core';

import { Shared } from '../../index';
import { HolidayNotification } from '../../../proxy/models/holiday-notification';
import { NotificationsPanelService, NotificationType } from '../../../core/services/notifications-panel.service';
import { ClickOutsideDirective } from '../../directives/click-outside.directive';
import { Notification } from '../../../proxy/models/common';
import { HolidayNotificationComponent } from './holiday-notification/holiday-notification.component';
import { SystemNotificationComponent } from './system-notification/system-notification.component';
import { NotificationsService } from '../../../core/services/notifications.service';

@Component({
  selector: 'app-notifications-panel',
  imports: [
    ClickOutsideDirective,
    Shared,
    HolidayNotificationComponent,
    SystemNotificationComponent,
  ],
  templateUrl: './notifications-panel-component.html',
  styleUrl: './notifications-panel-component.scss',
})
export class NotificationsPanelComponent {
  private systemNotificationsService = inject(NotificationsService);

  protected readonly NotificationType = NotificationType;

  public holidayNotifications = input<HolidayNotification[] | null>();
  public notifications = input<Notification[] | null>();
  public notificationsPanelService = inject(NotificationsPanelService);

  public closePanel(): void {
    this.notificationsPanelService.onOpenNotifications(null);
  }

  public changeTab(tab: NotificationType): void {
    if (tab === this.notificationsPanelService.openNotifications()) {
      return;
    }

    this.notificationsPanelService.onOpenNotifications(tab);
  }

  public deleteSystemNotification(notification: Notification): void {
    this.systemNotificationsService.deleteNotification(notification);
  }

  public updateSystemNotification(notification: Notification): void {
    this.systemNotificationsService.updateNotification(notification);
  }
}
